import { IdcardOutlined, KeyOutlined, LoginOutlined, MailOutlined, SaveOutlined, UserOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Card, Col, Divider, Input, message, notification, Row, Space, Typography } from 'antd'
import Title from 'antd/es/skeleton/Title';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateClientIdMutation, useUpdateUserMutation } from '../slices/usersApiSlice';
import { setCredentials } from "../slices/authSlice";
import ApiKeyForm from './Admin/Form/apiKeyForm';

const ProfileScreen = () => {
  const { Text } = Typography;
  const [api, contextHolder] = notification.useNotification();
  const { userInfo } = useSelector((state) => state.auth);
  const { darkmode } = useSelector((state) => state.darkmode);
  const [clientId, setClientId] = useState('');

  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [show, setShow] = useState(false);
  const [updateClientId] = useUpdateClientIdMutation();
  const dispatch = useDispatch();

  const visible = () => {
    show ? setShow(false) : setShow(true)
  }
  const [updateuser, { isLoading }] = useUpdateUserMutation();

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const res = await updateuser({ password }).unwrap();

      message.success('Profile updated successfully!');
    } catch (err) {

      api.error({
        message: err?.data?.message || err.error || err?.data?.error,
      });

    }
  }


  const handleClientIdSubmit = async () => {
    if (!clientId) {
      message.warning('Please enter your Client ID');
      return;
    }

    try {
      const res = await updateClientId(clientId).unwrap();

      dispatch(setCredentials({ ...userInfo, clientId: res.clientId }));
      message.success(`Client ID "${res.clientId}" saved successfully!`);
    } catch (err) {
      console.error(err);
      message.error(err?.data?.message || 'Failed to update Client ID');
    }
  };
  const referralLink = `${window.location.origin}/register?sponsor=${userInfo?._id}`;
  return (
    <>
      {contextHolder}
      <form onSubmit={(e) => handleUpdate(e)}>
        <Title level={2}><UserOutlined /> Profile</Title>
        <Row style={{ padding: "20px", backgroundColor: darkmode ? "#141414" : "#AFDDFF", borderRadius: "5px" }}>
          <Col flex={"auto"}>
            <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'User' }, { title: 'Profile' }]} style={{ marginBottom: "5px" }} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col md={8} xs={24}>
            <Card title="Profile"  >

              <Space direction='vertical' style={{ width: "100%" }}>
                <Input placeholder="First Name" value={userInfo.firstname} addonBefore={<UserOutlined />} disabled={true} />
                <Input placeholder="Last Name" value={userInfo.lastname} addonBefore={<UserOutlined />} disabled={true} />
                <Input placeholder="Email" value={userInfo.email} addonBefore={<MailOutlined />} disabled={true} />
                <Text>Change Password</Text>
                <Input.Password placeholder="Password" addonBefore={<KeyOutlined />} onChange={(e) => setPassword(e.target.value)} visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }} required />
                <Button type="primary" htmlType="submit" loading={isLoading}>Save <SaveOutlined /></Button>
                <Input
                  value={userInfo?._id}
                  addonBefore="sponsor_Id"
                  addonAfter={
                    <Button
                      size="small"
                      onClick={() => {
                        navigator.clipboard.writeText(referralLink);
                        message.success("sponsor_Id copied!");
                      }}
                    >
                      Copy
                    </Button>
                  }
                // disabled
                />
              </Space>

            </Card>
          </Col>
   <Col md={8} xs={24}>
            <ApiKeyForm />
          </Col>

          <Col md={8} xs={24}>
            <Card title="Angel-Client ID" style={{ marginLeft: "10px" }}>
              <Space direction="vertical" style={{ width: '100%' }}>


                <Input
                  placeholder="Enter Client ID"
                  value={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                  addonBefore={<IdcardOutlined />}
                />
                <Button
                  type="primary"
                  onClick={handleClientIdSubmit}
                >
                  Submit Client ID <LoginOutlined />
                </Button>
              </Space>
            </Card>
          </Col>
       

        </Row>
      </form>
    </>
  )
}

export default ProfileScreen